import React, { useState, useEffect, useContext , useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import Swal from "sweetalert2";

function ConceptosGastosCreate() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS_GASTOS = import.meta.env.VITE_URL_CONCEPTOS_GASTOS;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const [name, setName] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);

  const clear = () => {
    setName("");
  };

  const saveConceptosGastos = (event) => {
    event.preventDefault();
    if (submittingRef.current) return;
    submittingRef.current = true;
    setValidaBoton(false);
    axios
      .post(
        URL_CONCEPTOS_GASTOS,
        {
          name,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Concepto Gastos",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        submittingRef.current = false;
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea un Concepto</h3>
        <Form onSubmit={saveConceptosGastos}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Concepto
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Nombre del Concepto"
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button color="danger" href="/MenuGastos">
              Regresar
            </Button>
            </Row>
        </Form>
      </div>
    </>
  );
}

export default ConceptosGastosCreate;
